document.addEventListener('DOMContentLoaded', function (e) {
//overview scripts
	jQuery('.field--name-field-threat-overview > p:not(:empty)').eq(0).addClass('j-first');
  jQuery('.o-extremists__leader__body--wrap > p:not(:empty)').eq(1).addClass('j-second');
	jQuery('.o-extremists__leader__body--wrap > p:not(:empty)').eq(0).addClass('j-first');
	jQuery('.field--name-field-threat-overview > p:not(:empty)').eq(1).addClass('j-second');
	jQuery('.o-report__overview .m-threats__header__meta').appendTo('.j-first');
	jQuery('.o-report__overview .j-expand').click(function() {
		jQuery(this).addClass('j-hide');
		jQuery('.o-report__overview .field--name-field-threat-overview').addClass('j-expanded');
		jQuery('.o-report__overview .j-collapse').addClass('j-show');
	});
	jQuery('.o-report__overview .j-collapse').click(function() {
		jQuery(this).removeClass('j-show');
		jQuery('.o-report__overview .field--name-field-threat-overview').removeClass('j-expanded');
		jQuery('.o-report__overview .j-expand').removeClass('j-hide');
	});
	jQuery('.o-extremists__leader__body .j-expand').click(function() {
		jQuery(this).addClass('j-hide');
		jQuery('.o-extremists__leader__body--wrap').addClass('j-expanded');
		jQuery('.o-extremists__leader__body .j-collapse').addClass('j-show');
	});
	jQuery('.o-extremists__leader__body .j-collapse').click(function() {
		jQuery(this).removeClass('j-show');
		jQuery('.o-extremists__leader__body--wrap').removeClass('j-expanded');
		jQuery('.o-extremists__leader__body .j-expand').removeClass('j-hide');
	});
//.o-report__violent_activities  scripts
  jQuery('.field--name-field-violent-history > p:not(:empty)').eq(0).addClass('j-first');
	jQuery('.field--name-field-violent-history ul >li:not(:empty)').eq(2).addClass('j-list-3');
  jQuery('.o-report__violent_activities .j-expand').click(function() {
    jQuery(this).addClass('j-hide');
		jQuery('.o-report__violent_activities .field--name-field-violent-history').addClass('j-expanded');
		jQuery('.o-report__violent_activities .j-collapse').addClass('j-show');
	});
	jQuery('.o-report__violent_activities .j-collapse').click(function() {
		jQuery(this).removeClass('j-show');
		jQuery('.o-report__violent_activities .field--name-field-violent-history').removeClass('j-expanded');
		jQuery('.o-report__violent_activities .j-expand').removeClass('j-hide');
	});

	//tabs
	jQuery('.m-tabs__menu .m-tabs__link').eq(0).addClass('j-active');
	jQuery('.o-tabs .m-tabs__tab').eq(0).addClass('m-tabs__tab--active');
	jQuery('.m-tabs__menu .m-tabs__link').click(function() {
    var theitem = jQuery(this);
	  var thenum = theitem.parent().index();
		//alert(thenum);
		jQuery('.m-tabs__menu .m-tabs__link').removeClass('j-active');
		jQuery(this).addClass('j-active');
		jQuery('.m-tabs__tab').removeClass('m-tabs__tab--active');
		jQuery('.m-tabs__tab').eq(thenum).addClass('m-tabs__tab--active');
	});

	jQuery('.j-designations').click(function() {
		jQuery('.m-tabs__menu .m-tabs__link').removeClass('j-active');
		jQuery('.m-tabs__menu .m-tabs__link--a').addClass('j-active');
		jQuery('.m-tabs__tab').removeClass('m-tabs__tab--active');
		jQuery('.o-report__designations').addClass('m-tabs__tab--active');
	});

	jQuery('.j-associations').click(function() {
		jQuery('.m-tabs__menu .m-tabs__link').removeClass('j-active');
		jQuery('.m-tabs__menu .m-tabs__link--b').addClass('j-active');
		jQuery('.m-tabs__tab').removeClass('m-tabs__tab--active');
		jQuery('.o-report__associations').addClass('m-tabs__tab--active');
	});

	jQuery('.j-mediacoverage').click(function() {
		jQuery('.m-tabs__menu .m-tabs__link').removeClass('j-active');
		jQuery('.m-tabs__menu .m-tabs__link--c').addClass('j-active');
		jQuery('.m-tabs__tab').removeClass('m-tabs__tab--active');
		jQuery('.o-report__media').addClass('m-tabs__tab--active');
	});

	jQuery('.j-rhetoric').click(function() {
		jQuery('.m-tabs__menu .m-tabs__link').removeClass('j-active');
		jQuery('.m-tabs__menu .m-tabs__link--d').addClass('j-active');
		jQuery('.m-tabs__tab').removeClass('m-tabs__tab--active');
		jQuery('.o-report__rhetoric').addClass('m-tabs__tab--active');
	});
});
